import EncodeToBase64 from '../../components/base64encode';
import axios from 'axios';

const GetAuthKey = async (userName, password) => {
  const headers = { 'Authorization': EncodeToBase64(userName, password) };
  const authresponse = await axios.get('https://demoapi.skyspark.nl/api/v1/login2', {
    headers,
  });
  
  return authresponse;
};

export default GetAuthKey;